import { useEffect, useRef } from "react";

const BrowserData = () => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const browserData = {
      acceptHeader: "application/json",
      colorDepth: window.screen.colorDepth,
      javaEnabled: navigator.javaEnabled(),
      javaScriptEnabled: true,
      language: navigator.language,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      timeZoneOffset: new Date().getTimezoneOffset().toString(),
      userAgent: navigator.userAgent,
    };

    if (inputRef.current) {
      (inputRef.current as HTMLInputElement).value =
        JSON.stringify(browserData);
    }
  }, []);

  return (
    <input type="hidden" name="browserData" id="browserData" ref={inputRef} />
  );
};

export default BrowserData;
